import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule, CheckboxModule, InputModule, RadioModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BillingAdjustmentDomesticForm, BillingAdjustmentDomesticFormGroup } from '../../../models/cod-create.model';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { filter, tap } from 'rxjs';
import { Store } from '@ngxs/store';
import { AddCurrentCodLine, AddErrorMessage, RemoveErrorMessage } from '../../../state/cod.action';
import { WorkflowError } from '../../../../shared/enums/workflow-error';
import { ManagerSelectComponent } from '../../../../shared/components/manager-select/manager-select.component';

@Component({
    selector: 'app-cod-billing-adjustment-domestic-step',
    templateUrl: './billing-adjustment-domestic.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        TextareaModule,
        AttachmentsInputComponent,
        ManagerSelectComponent
    ],
    standalone: true
})
export class CodBillingAdjustmentDomesticStepComponent implements OnInit {
    @Input() billingAdjustmentDomesticForm: FormGroup<BillingAdjustmentDomesticFormGroup> | undefined;

    private relatedCallTrackingNumberTouched = false;

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.initFinancialAdjustmentChangesListener();
        this.initCallTagTrackingNumberTouchedListener();
        this.initRelatedDocumentsListener();
    }

    public isDefined(control: keyof BillingAdjustmentDomesticForm): boolean {
        return this.billingAdjustmentDomesticForm?.controls[control].value !== null;
    }

    public isTrue(control: keyof BillingAdjustmentDomesticForm): boolean {
        return this.billingAdjustmentDomesticForm?.controls[control].value === true;
    }

    public isFalse(control: keyof BillingAdjustmentDomesticForm): boolean {
        return this.billingAdjustmentDomesticForm?.controls[control].value === false;
    }

    public handleConfirm() {
        if (this.billingAdjustmentDomesticForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.billingAdjustmentDomesticForm?.valid ?? false;
    }

    private initFinancialAdjustmentChangesListener(): void {
        this.billingAdjustmentDomesticForm?.controls.financialAdjustment.valueChanges
            .pipe(
                filter(value => value === false),
                tap(() => this.billingAdjustmentDomesticForm?.controls.adjustmentAmount.setValue(0))
            )
            .subscribe();
    }

    private initCallTagTrackingNumberTouchedListener(): void {
        this.billingAdjustmentDomesticForm?.controls.callTagTrackingNumber.valueChanges
            .pipe(
                filter(() => !this.relatedCallTrackingNumberTouched),
                tap(() => {
                    this.store.dispatch(new AddErrorMessage(WorkflowError.UPLOAD_PROOF));

                    this.relatedCallTrackingNumberTouched = true;
                })
            )
            .subscribe();
    }

    private initRelatedDocumentsListener(): void {
        this.billingAdjustmentDomesticForm?.controls.relatedDocuments.valueChanges
            .pipe(
                filter(value => !!value && value.length > 0),
                tap(() => this.store.dispatch(new RemoveErrorMessage(WorkflowError.UPLOAD_PROOF)))
            )
            .subscribe();
    }
}
